import React, { Component } from 'react';
import PropTypes from 'prop-types';
import l10n from '../../lib/reactPPl10nHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import poll from '../../lib/poll';

const question = l10n.getContent('smarthelp/chatBot.message.question');
const bubbleText = l10n.getContent('smarthelp/chatBot.bubble.text');

class ChatBot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bubbleDisplay: 'hidden',
      opacity: '0',
    };
    this.handleClick = this.handleClick.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (this.props.display) {
      this.chatBotTracking();
    }
  }

  componentWillUpdate(nextProps) {
    if (this.props.display === false && nextProps.display === true) {
      this.chatBotTracking();
    }
  }

  onMouseEnter() {
    this.setState({ opacity: '1' });
    this.setState({ bubbleDisplay: 'visible' });
  }

  onMouseLeave() {
    this.setState({ opacity: '0' });
    this.setState({ bubbleDisplay: 'hidden' });
  }

  chatBotTracking() {
    const validateFpti = () => {
      if (!window.fpti) {
        return Promise.reject(false);
      }
      return Promise.resolve(window.fpti);
    };
    return poll(validateFpti, 4, 500)
      .then(() => trackPage({ link: this.props.link, id: this.props.id, hpid: this.props.hpid }))
      .catch(() => {});
  }

  handleClose(e) {
    this.setState({ bubbleDisplay: 'hidden' });
    e.cancelBubble = true; // otherwise, close will bubble up and invoke chat bot.
    if (e.stopPropagation) e.stopPropagation();
  }

  sessionChecker() {
    let bubbleLoaded;
    let firstLoad;
    try {
      bubbleLoaded = JSON.parse(sessionStorage.getItem('bubbleLoaded'));
      firstLoad = JSON.parse(sessionStorage.getItem('firstLoad'));
    } catch (err) {
      bubbleLoaded = bubbleLoaded || null;
      firstLoad = firstLoad || null;
    }
    if (bubbleLoaded === null) {
      const sessionObj = {
        helpCenter: {
          chatBot: {
            bubbleLoaded: true,
            firstLoad: true,
          },
        },
      };
      sessionStorage.setItem('bubbleLoaded', JSON.stringify(sessionObj));
      sessionStorage.setItem('firstLoad', JSON.stringify(sessionObj));
      return this.showChatBubble(bubbleLoaded);
    }
    if (firstLoad !== null) {
      return this.showChatBubble(firstLoad.helpCenter.chatBot.firstLoad);
    }
    return null;
  }

  showChatBubble(fade) {
    return (<div // eslint-disable-line jsx-a11y/no-static-element-interactions
      style={{ opacity: this.state.opacity, visibility: this.state.bubbleDisplay }}
      id="chat-question-bubble" onClick={this.handleClick} className={!fade ? 'chat-question-bubble fadein-fadeout' : 'chat-question-bubble'}
    >
      <p className="chatbot-question">{question}</p>
      <button onClick={this.handleClose} className="close-btn" />
      <p className="chatbot-text">{bubbleText}</p>
    </div>);
  }

  handleClick() {
    this.props.chatBotClicked();
    const chatbotClicked = sessionStorage && sessionStorage.getItem('chatBotClicked') === 'true';
    if (!chatbotClicked) {
      sessionStorage.setItem('chatBotClicked', 'true');
    }
    trackLink({ link: `${this.props.link}|clicked`, id: this.props.id, hpid: this.props.hpid });
    if (!Page.isLoggedIn()) {
      return null;
    }
    // eslint-disable-next-line no-undef
    if (typeof nodeChat !== 'undefined' && nodeChat) {
      // eslint-disable-next-line no-undef
      return nodeChat.show('chatBot', this.props.topicRefId);
    }
    return null;
  }

  hideChatBot() {
    return !this.props.display || Page.disableChatbotInMobileTablet();
  }

  render() {
    if (this.hideChatBot()) {
      return null;
    }
    return (
      <div id="smarthelp-chatBot-prompt" className="chatBot-prompt">
        {Page.isDesktopLayout() && this.sessionChecker()}
        <button tabIndex="0" aria-label="start-chat" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.handleClick} className="chatbot-btn" />
      </div>
    );
  }
}

ChatBot.propTypes = {
  id: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  hpid: PropTypes.string.isRequired,
  display: PropTypes.bool.isRequired,
  chatBotClicked: PropTypes.func,
  topicRefId: PropTypes.string,
};

ChatBot.defaultProps = {
  id: '',
  link: '',
  hpid: '',
  display: false,
  topicRefId: 'GENPOOL', // GENPOOL is generic topic id
  chatBotClicked: () => {},
};

export default ChatBot;
